import script from "./Bet.vue?vue&type=script&setup=true&lang=js"
export * from "./Bet.vue?vue&type=script&setup=true&lang=js"

import "./Bet.vue?vue&type=style&index=0&id=da988538&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da988538"]])

export default __exports__